define('consolehelpers',['edaphelpers'], function(edapHelpers) {
    'use strict';

    var validLogLevels = ['log', 'info', 'warn', 'error'];

    function ConsoleHelpers() {
        var consoleHelper = this,
            i,
            len;

        consoleHelper.validLogLevels = {};
        consoleHelper.logLevel = 'log';
        consoleHelper.enabled = true;


        /**
         *  Enables logging to console
         */
        consoleHelper.enable = function() {
            consoleHelper.enabled = true;
        };


        /**
         *  Disables logging to console
         */
        consoleHelper.disable = function() {
            consoleHelper.enabled = false;
        };


        /**
         *  Sets the console logging level to log messages
         *
         *  @param {String} [loglevel] - Console logging level to use to log messages
         *  @returns {Boolean} - If the logging level was set
         */
        consoleHelper.setLogLevel = function(loglevel) {
            if (consoleHelper.validLogLevels[loglevel]) {
                consoleHelper.logLevel = loglevel;
                return true;
            }

            return false;
        };


        /**
         *  Getter for logging level
         *
         *  @returns {String} - Returns the logging level
         */
        consoleHelper.getLogLevel = function() {
            return consoleHelper.logLevel;
        };


        /**
         *  Getter for the window.console, if it exists
         *
         *  @returns {Object} - Returns the window.console or null
         */
        consoleHelper.getConsole = function() {
            var win = edapHelpers.getWindow();

            if (win.console !== null && (typeof win.console === 'object' || typeof win.console === 'function')) {
                return win.console;
            }

            return null;
        };


        /**
         *  Contains the logic to determine if a log entry should be logged
         *
         *  @returns {Boolean} - If a log entry should be logged
         */
        consoleHelper.shouldLog = function() {
            var con;

            if (consoleHelper.enabled === false) {
                return false;
            }

            con = consoleHelper.getConsole();

            if (con === null) {
                return false;
            }

            return true;
        };


        /**
         *  Writes a log/logs to console
         *  Accepts a variable number of parameters that are passed through
         *  to console[logLevel]  ex. (assuming logLevel = 'log')
         *      console.log(str1, obj1, obj2);
         *
         *  @param {*} [arguments] - list of arguments to be apply()'d to the console
         */
        consoleHelper.log = function() {
            var con,
                logLevel;

            if (!consoleHelper.shouldLog()) {
                return;
            }

            con = consoleHelper.getConsole();
            logLevel = consoleHelper.getLogLevel();

            try {
                con[logLevel].apply(con, arguments);
            } catch (err) {
                // Do our best to log the message if we can
                if (logLevel !== 'log' && typeof con.log === 'function') {
                    con.log.apply(con, arguments);
                }
            }
        };


        /**
         *  Starts a console group() thread.
         *
         *  @param {String} [title] - Title of the console.group
         */
        consoleHelper.startLog = function(title) {
            var con;

            if (!consoleHelper.shouldLog()) {
                return;
            }

            con = consoleHelper.getConsole();

            if (typeof con.groupCollapsed === 'function') {
                con.groupCollapsed(title);
            } else if (typeof con.group === 'function') {
                con.group(title);
            } else {
                consoleHelper.log(title);
            }
        };


        /**
         *  Writes a log/logs to the end of a console group
         *  Accepts a variable number of parameters that are passed through
         *  to console.log. ex.
         *      console.log(str1, obj1, obj2);
         *
         *  @param {*} [arguments] - list of arguments to be apply()'d to this.log()
         */
        consoleHelper.endLog = function() {
            var con;

            if (!consoleHelper.shouldLog()) {
                return;
            }

            con = consoleHelper.getConsole();

            if (arguments.length > 0) {
                consoleHelper.log.apply(consoleHelper, arguments);
            }

            if (typeof con.groupEnd === 'function') {
                con.groupEnd();
            }
        };

        // Load up the validLogLevels object
        for (i = 0, len = validLogLevels.length; i < len; i++) {
            consoleHelper.validLogLevels[validLogLevels[i]] = true;
        }
    }

    return ConsoleHelpers;
});

